import { Component, EventEmitter, Output } from '@angular/core';

import { CacheService } from '../../../../shared/services/cache.service';
import { BaseMenuItemComponent } from '../base-menu-item.component';
import { SubmenuParticularPermissionsEnum } from '../enums/menu-permissions.enum';
import { MenuItemChild } from '../models/menu-item-child.model';
import { MenuUtilsService } from '../services/menu-utils.service';
import { MenuSharedService } from '../services/menu.shared.service';

@Component({
  selector: 'particular-menu-item',
  templateUrl: '../templates/menu-item.html',
  styleUrls: ['../scss/menu-item.scss'],
})
export class IclinicPayMenuItem extends BaseMenuItemComponent {
  menuCollapsed: boolean;
  isMobile: boolean = false;
  @Output() onClickSelect = new EventEmitter<any>();
  @Output() onClickItem = new EventEmitter<void>();

  constructor(
    menuSharedService: MenuSharedService,
    private cacheService: CacheService,
    menuUtilsService: MenuUtilsService
  ) {
    // Título, Array de Filhos, SVG, Ativo (sim ou não), altura da lista quando os subitems estiverem à mostra
    super(
      'Particular',
      'particular',
      [
        new MenuItemChild(
          'Pagamento online',
          '/pages/particular/pagamento-online',
          false,
          menuUtilsService.userHavePermission(
            SubmenuParticularPermissionsEnum.PAGAMENTO_ONLINE
          )
        ),
        new MenuItemChild(
          'Transações',
          '/pages/particular/transacoes',
          false,
          menuUtilsService.userHavePermission(SubmenuParticularPermissionsEnum.TRANSACOES)
        ),
        new MenuItemChild(
          'Recebíveis',
          '/pages/particular/recebiveis',
          false,
          menuUtilsService.userHavePermission(SubmenuParticularPermissionsEnum.RECEBIVEIS)
        ),
      ],
      `<svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.9775 12.5681L18.87 4.13625C18.7888 3.81159 18.6015 3.52338 18.3376 3.31749C18.0738 3.1116 17.7487 2.99984 17.4141 3H11.25V1.5C11.25 1.10218 11.092 0.720644 10.8107 0.43934C10.5294 0.158035 10.1478 0 9.75 0H6C5.60218 0 5.22064 0.158035 4.93934 0.43934C4.65804 0.720644 4.5 1.10218 4.5 1.5V3H3.58594C3.25128 2.99984 2.92619 3.1116 2.66237 3.31749C2.39855 3.52338 2.21115 3.81159 2.13 4.13625L0.0225001 12.5681C0.00752797 12.6276 -2.9411e-05 12.6887 8.60125e-08 12.75V15.75C8.60125e-08 16.1478 0.158035 16.5294 0.43934 16.8107C0.720644 17.092 1.10218 17.25 1.5 17.25H19.5C19.8978 17.25 20.2794 17.092 20.5607 16.8107C20.842 16.5294 21 16.1478 21 15.75V12.75C21 12.6887 20.9925 12.6276 20.9775 12.5681ZM14.25 6H15.75C15.9489 6 16.1397 6.07902 16.2803 6.21967C16.421 6.36032 16.5 6.55109 16.5 6.75C16.5 6.94891 16.421 7.13968 16.2803 7.28033C16.1397 7.42098 15.9489 7.5 15.75 7.5H14.25C14.0511 7.5 13.8603 7.42098 13.7197 7.28033C13.579 7.13968 13.5 6.94891 13.5 6.75C13.5 6.55109 13.579 6.36032 13.7197 6.21967C13.8603 6.07902 14.0511 6 14.25 6ZM14.25 9H15.75C15.9489 9 16.1397 9.07902 16.2803 9.21967C16.421 9.36032 16.5 9.55109 16.5 9.75C16.5 9.94891 16.421 10.1397 16.2803 10.2803C16.1397 10.421 15.9489 10.5 15.75 10.5H14.25C14.0511 10.5 13.8603 10.421 13.7197 10.2803C13.579 10.1397 13.5 9.94891 13.5 9.75C13.5 9.55109 13.579 9.36032 13.7197 9.21967C13.8603 9.07902 14.0511 9 14.25 9ZM11.25 6C11.4489 6 11.6397 6.07902 11.7803 6.21967C11.921 6.36032 12 6.55109 12 6.75C12 6.94891 11.921 7.13968 11.7803 7.28033C11.6397 7.42098 11.4489 7.5 11.25 7.5H9.75C9.55109 7.5 9.36032 7.42098 9.21967 7.28033C9.07902 7.13968 9 6.94891 9 6.75C9 6.55109 9.07902 6.36032 9.21967 6.21967C9.36032 6.07902 9.55109 6 9.75 6H11.25ZM12 9.75C12 9.94891 11.921 10.1397 11.7803 10.2803C11.6397 10.421 11.4489 10.5 11.25 10.5H9.75C9.55109 10.5 9.36032 10.421 9.21967 10.2803C9.07902 10.1397 9 9.94891 9 9.75C9 9.55109 9.07902 9.36032 9.21967 9.21967C9.36032 9.07902 9.55109 9 9.75 9H11.25C11.4489 9 11.6397 9.07902 11.7803 9.21967C11.921 9.36032 12 9.55109 12 9.75ZM6 1.5H9.75V3H6V1.5ZM5.25 6H6.75C6.94891 6 7.13968 6.07902 7.28033 6.21967C7.42098 6.36032 7.5 6.55109 7.5 6.75C7.5 6.94891 7.42098 7.13968 7.28033 7.28033C7.13968 7.42098 6.94891 7.5 6.75 7.5H5.25C5.05109 7.5 4.86032 7.42098 4.71967 7.28033C4.57902 7.13968 4.5 6.94891 4.5 6.75C4.5 6.55109 4.57902 6.36032 4.71967 6.21967C4.86032 6.07902 5.05109 6 5.25 6ZM5.25 9H6.75C6.94891 9 7.13968 9.07902 7.28033 9.21967C7.42098 9.36032 7.5 9.55109 7.5 9.75C7.5 9.94891 7.42098 10.1397 7.28033 10.2803C7.13968 10.421 6.94891 10.5 6.75 10.5H5.25C5.05109 10.5 4.86032 10.421 4.71967 10.2803C4.57902 10.1397 4.5 9.94891 4.5 9.75C4.5 9.55109 4.57902 9.36032 4.71967 9.21967C4.86032 9.07902 5.05109 9 5.25 9ZM19.5 15.75H1.5V13.5H19.5V15.75Z" fill="white" fill-opacity="0.89"/>
</svg>
`,
      false,
      false,
      '0px',
      menuSharedService,
      menuUtilsService
    );

    this.menuSharedService.getSubItemsOf().subscribe((title) => {
      if (title === this.title && !this.showChildren) {
        this.showChildren = true;
        this.heightWhenShowingChildren = menuUtilsService.calculateSubmenuHeight(
          this.children
        );
      } else {
        this.showChildren = false;
        this.heightWhenShowingChildren = '0px';
      }
    });
  }

  async ngOnInit() {
    this.menuSharedService.getMenuCollapsed().subscribe((menuCollapsed) => {
      this.menuCollapsed = menuCollapsed;
      this.heightWhenShowingChildren =
        menuCollapsed || this.isMobile ? '0px' : this.heightWhenShowingChildren;

      if (this.menuCollapsed && this.showChildren) {
        this.showChildren = false;
      }
    });

    let routerData = await this.cacheService.getRouterGuardData().toPromise();
    if (!routerData.data.seller_amount) {
      this.children = [];
      this.route = '/pages/dados-cadastrais/unidade/create/true';
    }

    if (window.innerWidth <= 500 || screen.width <= 500) {
      this.isMobile = true;
    }
  }

  override toggleItemChildren() {
    super.toggleItemChildren();
    this.onClickSelect.emit({ title: this.title, children: this.children });
    this.isMobile = window.innerWidth <= 500 || screen.width <= 500 ? true : false;
  }

  override menuItemClicked() {
    super.menuItemClicked();
    this.onClickItem.emit();
  }
}
